var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75098 0C10.1652 0 10.501 0.335786 10.501 0.75V10.1893L13.4394 7.25092C13.7323 6.95803 14.2072 6.95803 14.5001 7.25092C14.7929 7.54381 14.7929 8.01869 14.5001 8.31158L10.2813 12.5303C10.2094 12.6022 10.1265 12.6565 10.0381 12.6931C9.94963 12.7298 9.85267 12.75 9.75098 12.75C9.64928 12.75 9.55232 12.7298 9.46389 12.6931C9.37543 12.6565 9.29255 12.6022 9.22065 12.5303L5.0019 8.31158C4.709 8.01869 4.709 7.54381 5.0019 7.25092C5.29479 6.95803 5.76966 6.95803 6.06256 7.25092L9.00098 10.1893V0.75C9.00098 0.335786 9.33676 0 9.75098 0ZM1.5 12.4844C1.5 12.0702 1.16421 11.7344 0.75 11.7344C0.335786 11.7344 0 12.0702 0 12.4844V14.8177C0 15.7238 0.359967 16.5929 1.00072 17.2336C1.64146 17.8744 2.51049 18.2344 3.41667 18.2344H12.25C12.6642 18.2344 13 17.8986 13 17.4844C13 17.0702 12.6642 16.7344 12.25 16.7344H3.41667C2.90835 16.7344 2.42084 16.5324 2.06138 16.173C1.70194 15.8135 1.5 15.326 1.5 14.8177V12.4844ZM19.5 12.4844C19.5 12.0702 19.1642 11.7344 18.75 11.7344C18.3358 11.7344 18 12.0702 18 12.4844V14.8177C18 15.326 17.798 15.8135 17.4386 16.173C17.0792 16.5324 16.5916 16.7344 16.0833 16.7344C15.6691 16.7344 15.3333 17.0702 15.3333 17.4844C15.3333 17.8986 15.6691 18.2344 16.0833 18.2344C16.9895 18.2344 17.8585 17.8744 18.4993 17.2336C19.14 16.5929 19.5 15.7238 19.5 14.8177V12.4844Z",
    fill: "#191818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.61725c8702d1a18dfae447b70e971618.svg";
export { ForwardRef as ReactComponent };